import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import {
  httpErrorInterceptor,
  loadingInterceptor,
  tokenInterceptor,
} from '@interceptors';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { routes } from './app.routes';
import { provideCountries } from './providers/countries.provider';
import { provideIcons } from './providers/custom-icon.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        tokenInterceptor,
        httpErrorInterceptor,
        loadingInterceptor,
      ]),
    ),
    provideIcons(),
    provideAnimationsAsync(),
    provideAngularSvgIcon(),
    provideCountries(),
    CookieService,
    ConfirmationService,
    DialogService,
    MessageService,
  ],
};
